import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class OrchimaCleanup extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false
  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);



  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    this.setState({ showOrderForm:!this.state.showOrderForm });
  };

  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }

  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

  }

  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }


  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;


    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {

      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {

        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {

          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

            }
          }
        }
      }
    }

    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',

  handleAddress2Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }



  render() {
    let shorOrderFormButtonText="";
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    if( !this.state.showOrderForm){
      shorOrderFormButtonText = "Show Order Form";
    }else{
      shorOrderFormButtonText = "Hide Order Form";
    }
    return (

      <div id="top1"  style={{ width:'100%' }}>

        <Typography variant="h6" component="h2" style = { { marginTop:30, textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
          Product Disclaimer
        </Typography>
        <Grid container spacing={24} >
          <Grid item xs={0} sm={0}  md={1} lg={1}   xl={1}>

          </Grid>
          <Grid item xs={12} sm={12}  md={10} lg={10}   xl={10}>

            <a href="/Home"   rel="noreferrer">
              <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                Back to Orchima Home
              </Typography>
            </a>
            <div style = { {textAlign: 'justify', alignSelf:'justify', paddingTop:'200', marginBottom:'100',  marginTop:20, width:'100%'}}>
              <Grid container spacing={24}  style={{marginLeft:20, textAlign: 'left', alignSelf: 'left', backgroundColor:'white'}} >
                <Grid item xs={2} sm={2}  md={2} lg={2}   xl={2}>

                </Grid>
                <Grid item xs={8} sm={8}  md={8} lg={8}   xl={8}>
                  <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                    <div  style={{display: 'flex',
                      flexDirection: 'row' }}>
                      <Typography  style={{fontSize:16 , textAlign: 'justify', alignSelf:'justify'  , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}> Disclaimer and Limitation of Liability.
                        The Orchima™ pot has been thoughtfully designed for home and decorative use with bark-based orchid planting media. Please read and follow all care and usage instructions provided.</Typography>

                    </div>

                  </Grid>
                  <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                    <div  style={{display: 'flex',
                      flexDirection: 'row' }}>
                      <Typography  style={{fontSize:16 , textAlign: 'justify', alignSelf:'justify'  , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}>
                        By purchasing or using this product, the user acknowledges and agrees that Orchima™ and its affiliates are not responsible or liable for
                        any direct, indirect, incidental, or consequential damages resulting from improper use, misuse, modification,
                        or failure to follow the provided instructions.</Typography>
                    </div>

                  </Grid>
                  <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                    <div  style={{display: 'flex',
                      flexDirection: 'row' }}>
                      <Typography  style={{fontSize:16 , textAlign: 'justify', alignSelf:'justify'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}>
                        The user assumes full responsibility for ensuring that use of the product is appropriate for their environment and
                        does not cause damage to plants, furnishings, surfaces, or property.
                      </Typography>
                    </div>

                  </Grid>
                  <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                    <div  style={{display: 'flex',
                      flexDirection: 'row' }}>
                      <Typography  style={{fontSize:16 , textAlign: 'justify', alignSelf:'justify'  , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}>

                        Orchima™ makes no express or implied warranties beyond those required by applicable law, including but not limited to implied
                        warranties of merchantability or fitness for a particular purpose.
                        If the product is found defective, liability shall be limited solely to
                        the replacement of the product or refund of its purchase price, at the company’s discretion.</Typography>
                    </div>

                  </Grid>
                </Grid>
                <Grid item xs={2} sm={2}  md={2} lg={2}   xl={2}>

                </Grid>

              </Grid>
            </div>
              <br/>
              <a href="/Home"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                  Back to Orchima Home
                </Typography>
              </a>
          </Grid>
          <Grid item xs={0} sm={0}  md={1} lg={1}   xl={1}>

          </Grid>
        </Grid>
      </div>



    );
  }
}

OrchimaCleanup.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,

    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,

  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchimaCleanup));
